/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * dataprocessLog
 */
export interface DataprocessLog { 
    id?: number;
    /**
     * Time at which the data importer was used
     */
    tstamp?: string;
    /**
     * The user name that used the DataImporter
     */
    username?: string;
    /**
     * result from DataImporter
     */
    stepresult?: string;
    rc?: number;
}

